export const REGULATIONS_REQUEST = 'REGULATIONS_REQUEST';
export const REGULATIONS_REQUEST_SUCCEEDED = 'REGULATIONS_REQUEST_SUCCEEDED';
export const REGULATIONS_REQUEST_FAILED = 'REGULATIONS_REQUEST_FAILED';

export const REGULATIONS_SHOW_REQUEST = 'REGULATIONS_SHOW_REQUEST';
export const REGULATIONS_SHOW_REQUEST_SUCCEEDED = 'REGULATIONS_SHOW_REQUEST_SUCCEEDED';
export const REGULATIONS_SHOW_REQUEST_FAILED = 'REGULATIONS_SHOW_REQUEST_FAILED';
